import React, { useState } from 'react'
import Palette from './Palette'
import { NavLink } from 'react-router-dom'
import '../styles/SavedPalette.css'

const SavedPalette = ({setPalette, setSuggest, setMain, setButtonState}) => {
  const [palettes, setPalettes] = useState(JSON.parse(localStorage.getItem("palette")) || [])
  return (
    <div className='saved-palette-page'>
        <nav className='color-suggestion-nav'>
            <ul>
                <li>
                    <NavLink 
                        to='/color-palette' 
                        end
                        className={({isActive}) => `navlink link ${isActive ? 'active' : ''}`}
                    >Generate Palette</NavLink>
                </li>
                <li>
                    <NavLink 
                        to='/color-palette/saved-palette' 
                        end
                        className={({isActive}) => `navlink link ${isActive ? 'active' : ''}`}
                    >Saved Palettes</NavLink>
                </li>
            </ul>
        </nav>
        <h2>Saved Palettes</h2>
        {palettes.length === 0 ? <p>There are no saved palettes</p> : <main className="saved-palette-container">
            {palettes.map((palette, id) => (
                <Palette palette={palette} setPalettes={setPalettes} id={id} setPalette={setPalette} setSuggest={setSuggest} setMain={setMain} key={id} setButtonState={setButtonState}/>
            ))}
        </main>}
    </div>
  )
}

export default SavedPalette